<template>
    <div class="mt-3 px-4">
        <div class="card col-12 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 p-4">
            <h1>{{ $t('user_data.header') }}</h1>
            <div class="row">
                <div class="col-12">
                    <validation-errors :errors="errors" v-if="errors" ref="errors_container" />
                    <form
                        action="#"
                        method="POST"
                        @submit.prevent="handleSubmit"
                    >
                        <div class="form-group col-12">
                            <label for="firstName">{{ $t('auth.first_name') }}<span class="text-danger"> *</span></label>
                            <input
                                id="firstName"
                                type="text"
                                class="form-control"
                                name="firstName"
                                required
                                v-model="firstName"
                            >
                        </div>
                        <div class="form-group col-12">
                            <label for="lastName">{{ $t('auth.last_name') }}<span class="text-danger"> *</span></label>
                            <input
                                id="lastName"
                                type="text"
                                class="form-control"
                                name="lastName"
                                required
                                v-model="lastName"
                            >
                        </div>
                        <div class="form-group col-12">
                            <label>{{ $t('auth.profile.phone') }}<span class="text-danger"> *</span></label>
                            <phone-input
                                input-class="form-control"
                                :value="phoneNumber"
                                required
                                @input="onPhoneInput($event)"
                            />
                        </div>
                        <div v-if="isCompany">
                            <div class="form-group col-12">
                                <label for="corporateName">{{ $t('company_name') }}<span class="text-danger"> *</span></label>
                                <input
                                    id="corporateName"
                                    type="text"
                                    class="form-control"
                                    name="corporateName"
                                    required
                                    v-model="corporateName"
                                >
                            </div>
                            <div class="form-group col-12">
                                <label for="nip">{{ $t('auth.profile.tax_number') }}<span class="text-danger"> *</span></label>
                                <input
                                    id="nip"
                                    type="text"
                                    class="form-control"
                                    name="nip"
                                    disabled
                                    required
                                    v-model="nip"
                                >
                            </div>
                            <div class="form-group col-12">
                                <label for="addressStreet">{{ $t('street') }}<span class="text-danger"> *</span></label>
                                <input
                                    id="addressStreet"
                                    type="text"
                                    class="form-control"
                                    name="addressStreet"
                                    required
                                    v-model="addressStreet"
                                >
                            </div>
                            <div class="form-group col-12">
                                <label for="addressBuildingNumber">{{ $t('building_number') }}<span class="text-danger"> *</span></label>
                                <input
                                    id="addressBuildingNumber"
                                    type="text"
                                    class="form-control"
                                    name="addressBuildingNumber"
                                    required
                                    v-model="addressBuildingNumber"
                                >
                            </div>
                            <div class="form-group col-12">
                                <label for="addressApartmentNumber">{{ $t('apartment_number') }}</label>
                                <input
                                    id="addressApartmentNumber"
                                    type="text"
                                    class="form-control"
                                    name="addressApartmentNumber"
                                    v-model="addressApartmentNumber"
                                >
                            </div>
                            <div class="form-group col-12">
                                <label for="addressPostal">{{ $t('post_code') }}<span class="text-danger"> *</span></label>
                                <input
                                    id="addressPostal"
                                    type="text"
                                    class="form-control"
                                    name="addressPostal"
                                    required
                                    v-model="addressPostal"
                                >
                            </div>
                            <div class="form-group col-12">
                                <label for="addressCity">{{ $t('city') }}<span class="text-danger"> *</span></label>
                                <input
                                    id="addressCity"
                                    type="text"
                                    class="form-control"
                                    name="addressCity"
                                    required
                                    v-model="addressCity"
                                >
                            </div>
                            <div class="form-group col-12">
                                <label for="addressCountry">{{ $t('country') }}<span class="text-danger"> *</span></label>
                                <select id="addressCountry" class="form-control" name="addressCountry" required v-model="addressCountry">
                                    <option :value="value" v-for="(label, value) in countries" :key="value">{{ label }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group col-12">
                            <div class="col-form-label">
                                <p><span class="text-danger"> *</span> {{ $t('auth.required_fields_info') }}</p>
                            </div>
                        </div>
                        <div class="form-group col-12">
                            <button type="submit" class="btn btn-primary" :disabled="loading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                                {{ $t('user_data.submit') }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import toastr from 'toastr';
    import backofficeRepository from '@repositories/BackofficeRepository';
    import ValidationErrors from '@components/ValidationErrors.vue';
    import backofficeMapsRepository from '@repositories/BackofficeMapsRepository';

    export default {
        components: {ValidationErrors},
        data() {
            return {
                firstName: this.$store.state.user.firstName,
                lastName: this.$store.state.user.lastName,
                corporateName: this.$store.state.user.corporateName,
                phoneNumber: this.$store.state.user.phoneNumber,
                addressStreet: this.$store.state.user.addressStreet,
                addressBuildingNumber: this.$store.state.user.addressBuildingNumber,
                addressApartmentNumber: this.$store.state.user.addressApartmentNumber,
                addressPostal: this.$store.state.user.addressPostal,
                addressCity: this.$store.state.user.addressCity,
                addressCountry: this.$store.state.user.addressCountry,
                nip: this.$store.state.user.nip,
                countries: this.$t('auth.countries'),
                loading: false,
                errors: [],
            };
        },
        computed: {
            isCompany() {
                return this.$store.state.user.is_company;
            },
        },
        methods: {
            handleSubmit() {
                this.loading = true;
                backofficeRepository.isTokenValid().then((isTokenValid) => {
                    if(!isTokenValid){
                        this.$store.dispatch('user/unsetUser');
                        toastr.error(this.$t('auth.session_expired'));
                        this.$router.push({ name: 'login.index', query: {redirectTo: this.$route.fullPath} });
                        return;
                    }

                    let data = {
                        firstName: this.firstName,
                        lastName: this.lastName,
                        phoneNumber: this.phoneNumber,
                    };
                    if(this.isCompany){
                        data.corporateName = this.corporateName;
                        data.addressStreet = this.addressStreet;
                        data.addressBuildingNumber = this.addressBuildingNumber;
                        data.addressApartmentNumber = this.addressApartmentNumber ? this.addressApartmentNumber : null;
                        data.addressPostal = this.addressPostal;
                        data.addressCity = this.addressCity;
                        data.addressCountry = this.addressCountry;
                    }

                    if (this.validatePhone()) {
                        backofficeRepository.editClientUserMe(data).then((resp) => {
                            if(resp.data.editClientUserMe.id){
                                //update user model
                                backofficeRepository.getCurrentUser().then((userData) => {
                                    let user = userData.data.me;
                                    //add all internal properties of userData.data.me.clientProfile.client to user
                                    Object.assign(user, userData.data.me.clientProfile.client);
                                    this.$store.dispatch('user/setUser', user);
                                    toastr.success(this.$t('data_updated_success'));
                                });
                            }
                            else{
                                toastr.error(this.$t('general_error'));
                            }
                        }).catch((error) => {
                            this.errors = backofficeMapsRepository.parseAPIErrors(error);
                            //scroll to error
                            this.$nextTick(() => {
                                this.$refs.errors_container.$el.scrollIntoView({ behavior: 'smooth' });
                            });
                        }).finally(() => {
                            this.loading = false;
                        });
                    }
                });
            },

            validatePhone() {
                if (
                    this.phoneNumber &&
                    (this.phoneNumber.length < 11 || this.phoneNumber.length > 13)
                ) {
                    toastr.error(
                        this.$t('airport_transfers.pages.phone_length_error')
                    );
                    return false;
                }

                return true;
            },

            onPhoneInput(value) {
                this.phoneNumber = value;
            },
        },
    };
</script>
